export default {
    route: {
        index_page: '首页',
        help: '帮组',
        mpanel: '常用面板',
        table_selector: '表格选择',
        button_authority: '认证按钮',
        multi_language: '多语言',
        not_found: '404页面'
    },
    multiLanguage: {
        desc: `<p>Mdea - cliは中国語、英語、日本語の3言語の国際化をサポートしております：</p>
                <br>
                <h3>1、後端に配置された多言語</h3>
                <br>
                <p>主に使用するシーンはメニューの複数の言語の配置であり、メニューの名前を添付して中国語、英語、日本語を入力することができる。</p>
                <br>
                <h3>2、先端配置の多言語</h3>
                <br>
                <p>先端多言語の配置は、プロジェクトの本目録のscr／langディレクトリの下に、コミットフォルダに配置されている共通のコンポーネントの多言語情報であり、
                mdilesに配置されたのは、モジュール下の多言語情報であり、具体的な構成はフレーム内にある複数の言語構成を参照することができる。</p>
                <br>
                <h4>備考：この枠はメニュー、共用コンポーネント、そしてこのページに国際化され、他のページは国際化していない。</h4>`
    }
};
